import { Component } from '@theme/component';
import { loadQuickAddModal } from '@theme/esc-quick-add-modal';

class EscProductCard extends Component {
  /** @type {number} */
  #requestId = 0;

  async showModal() {
    const handle = this.dataset.productHandle;
    if (!handle) return;

    const requestId = ++this.#requestId;
    this.#setLoading(true);

    try {
      const modal = await loadQuickAddModal(handle);
      if (requestId !== this.#requestId) return;

      document.body.appendChild(modal);
      modal.showModal();
    } catch (error) {
      if (requestId !== this.#requestId) return;
      window.location.href = `/products/${handle}`;
    } finally {
      if (requestId === this.#requestId) this.#setLoading(false);
    }
  }

  /**
   * @param {boolean} isLoading
   */
  #setLoading(isLoading) {
    const button = this.refs.quickAddButton;
    if (!(button instanceof HTMLButtonElement)) return;

    button.disabled = isLoading;
    button.toggleAttribute('aria-busy', isLoading);
  }
}

if (!customElements.get('esc-product-card')) {
  customElements.define('esc-product-card', EscProductCard);
}
